import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	collapseButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-expand-button.collapse-button',
		defaultMessage: 'Collapse button',
		description: 'The label for the collapse button of slack button when it is in expand state.',
	},
	expandButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-expand-button.expand-button',
		defaultMessage: 'Expand button',
		description: 'The label for the expand button of slack button when it is in collapse state.',
	},
});
